import { AngularFireStorageModule } from "@angular/fire/storage";
import { BsDropdownModule } from "ngx-bootstrap";
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF, registerLocaleData } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import localeFr from "@angular/common/locales/fr";
import { LOCALE_ID, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CoreModule } from "./@core/core.module";
import { LoginComponent } from "./pages/login/login.component";
import { AngularFireModule } from "@angular/fire";
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatOptionModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRippleModule,
  MatSelectModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatTreeModule,
} from "@angular/material";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "../environments/environment";
import { ThemeModule } from "./@theme/theme.module";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AuthGuard } from "./shared/guards/auth.guard";
import { AuthService } from "./shared/services/auth.service";
import { ClientAccessService } from "./shared/services/client-access.service";
import { ConteneurAccessService } from "./shared/services/conteneur-access.service";
import { DataAccessHelpersService } from "./shared/services/data-access-helpers.service";
import { NbMenuModule } from "@nebular/theme";
import { TranslocoRootModule } from "./transloco/transloco-root.module";
import { AdminAuthGuard } from "./shared/guards/adminAuth.guard";
import { ResetPasswordModule } from "./pages/shared/reset-password/reset-password.module";
// import { GateInRemorqueComponent } from './pages/gate-in-remorque/gate-in-remorque.component';



registerLocaleData(localeFr);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    // GateInRemorqueComponent,
    // SafeHtmlPipe,
  ],

  imports: [
    MatProgressSpinnerModule,
    ResetPasswordModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatTreeModule,
    MatIconModule,
    MatCheckboxModule,
    MatGridListModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatDividerModule,
    MatToolbarModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatTabsModule,
    MatToolbarModule,
    MatMenuModule,
    MatDividerModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatChipsModule,
    MatTooltipModule,
    MatListModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatGridListModule,
    MatCheckboxModule,
    MatTabsModule,
    MatExpansionModule,
    MatButtonToggleModule,
    MatRippleModule,
    AngularFireModule.initializeApp(environment.firebase),
    //AngularFirestoreModule.enablePersistence({synchronizeTabs:true}),
    AngularFirestoreModule,
    AngularFireStorageModule,

    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    BsDropdownModule.forRoot(),
    NbMenuModule.forRoot(),
    TranslocoRootModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: APP_BASE_HREF, useValue: "/" },
    { provide: LOCALE_ID, useValue: "fr" }, // Setting french locale
    AuthService,
    AngularFireAuth,
    AuthGuard,
    AdminAuthGuard,
    ClientAccessService,
    ConteneurAccessService,
    DataAccessHelpersService,
  ],
})
export class AppModule {}
